<template>
    <div class="weui-tab">
        <div class="weui-navbar">
            <div class="weui-navbar__item" :class="navItemClass(0)" @click="navItemClicked(0)">
                免费
            </div>
            <div class="weui-navbar__item" :class="navItemClass(1)" @click="navItemClicked(1)">
                会员
            </div>
        </div>
        <div class="weui-tab__panel">
            <keep-alive>
                <component :is="currentNav"></component>
            </keep-alive>
        </div>
    </div>
</template>

<script>
import NavFree from "./navs/Free";
import NavMember from "./navs/Member";

export default {
    name: "Service",
    data() {
        return {
            navs:['NavFree', 'NavMember'],
            selectedIndex: 0
        };
    },
    computed:{
        currentNav(){
            return this.navs[this.selectedIndex];
        }
    },
    methods: {
        navItemClass(index) {
            return this.selectedIndex == index ? 'weui-bar__item_on' : '';
        },
        navItemClicked(index) {
            this.selectedIndex = index;
        }
    },
    components: {
        NavFree,
        NavMember
    }
};
</script>
